import { useCallback } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { buildNurseShift, type NurseShiftDraft } from "../utils/buildNurseShift";
import type { NurseInShift } from "../utils/models";
import { useDepartmentFlags } from "./useDepartmentFlags";
import { useLastNameFirst } from "./useNameFormat";

/** The shift an add puts a nurse on, without HospitalDataProvider: the provider's `prepareDataForAddNurse`. */
export const usePrepareNurseShift = (): ((draft: NurseShiftDraft) => NurseInShift) => {
	const { chosenDepartment } = useChosenDepartment();
	const { isHospital } = useDepartmentFlags();
	const lastNameFirst = useLastNameFirst();
	return useCallback(
		(draft: NurseShiftDraft) => buildNurseShift(draft, chosenDepartment, isHospital, lastNameFirst),
		[chosenDepartment, isHospital, lastNameFirst],
	);
};
